export default __webpack_public_path__ + "static/dummy_banner-1a4bbc203645df3c466f6fbd28cabb20.png";